module.exports = __webpack_public_path__ + "mr.svg?a8f6d9d85c3bae4029bf733c4e29dc08";